import PropTypes from 'prop-types';
import {usePermissions} from 'packages/common/hooks/session';

const RoleBasedDisplay = ({allowedRoles, children}) => {
  const {userRole} = usePermissions();

  if (!allowedRoles.includes(userRole)) {
    return null;
  }

  return <>{children}</>;
};

RoleBasedDisplay.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
};

export default RoleBasedDisplay;
